import { render, staticRenderFns } from "./CardAtividades.vue?vue&type=template&id=0d3ce3f8&scoped=true"
import script from "./CardAtividades.vue?vue&type=script&lang=js"
export * from "./CardAtividades.vue?vue&type=script&lang=js"
import style0 from "./CardAtividades.vue?vue&type=style&index=0&id=0d3ce3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ce3f8",
  null
  
)

export default component.exports